import callMutation from 'shared/relay/mutations/call-mutation';
import classificationMutation from './classification.mutation';

const ClassificationService = {};

ClassificationService.send = ({
  packageId,
  instructions = null,
  classificationType = null,
  additionalReceivers = null,
  successCallback,
  failureCallback
}) => {
  const variables = {
    input: {
      packageId,
      clientMutationId: ''
    }
  };

  if (classificationType) {
    variables.input.classificationType = classificationType;
  }

  if (additionalReceivers) {
    variables.input.additionalReceivers = additionalReceivers;
  }

  if (instructions) {
    variables.input.instructions = instructions;
  }

  const callbacks = {
    onSuccess: response => successCallback(response),
    onFailure: () => failureCallback()
  };

  return callMutation(classificationMutation, variables, callbacks);
};

export default ClassificationService;
